import React, { useState } from 'react'
import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'
import { Select, Button, notification } from 'antd'
import { deliveryQuery } from './index'
import t from 'lib/translations'
const { Option } = Select

const addProductToBookingMutation = gql`
  mutation AddProductToBookingMutation($input: AddProductToBookingInput!) {
    AddProductToBooking(input: $input) {
      product {
        id
        name
      }
    }
  }
`

interface Props {
  bookingId: string
  availableProductsToSupplement: string[]
}

const SupplementalProducts = ({
  bookingId,
  availableProductsToSupplement,
}: Props) => {
  const [selectedProduct, setSelectedProduct] = useState('')

  const [addProductToBooking, { loading: isSubmitting }] = useMutation(
    addProductToBookingMutation,
    {
      refetchQueries: [{ query: deliveryQuery, variables: { bookingId } }],
      onCompleted: (result) => {
        const name = result.AddProductToBooking.product.name
        notification.success({
          message: `${name} ble lagt til`,
        })
      },
      onError: (err) => {
        console.error(err)
        notification.error({
          message: 'Noe gikk galt',
          description:
            'Kunne ikke legge til produkt grunnet en feil. Forsøk på nytt senere eller kontakt EFKT kundeservice.',
        })
      },
    }
  )

  const handleChange = (value: string) => {
    setSelectedProduct(value)
  }

  const handleSubmit = async () => {
    addProductToBooking({
      variables: {
        input: {
          bookingId,
          productType: selectedProduct,
        },
      },
    })
  }

  return (
    <div className="supplemental-products">
      <h3>Legg til produkt</h3>
      <Select
        onChange={handleChange}
        defaultValue="Velg produkt"
        className="select-product"
        listHeight={500}
      >
        {availableProductsToSupplement.map((product) => (
          <Option key={product} value={product}>
            {t(`products.${product}`)}
          </Option>
        ))}
      </Select>
      <Button
        type="primary"
        disabled={!selectedProduct}
        loading={isSubmitting}
        onClick={handleSubmit}
      >
        Opprett
      </Button>
    </div>
  )
}

export default SupplementalProducts
